import { render } from "./ProjectHistory.vue?vue&type=template&id=498fe5aa"
import script from "./ProjectHistory.vue?vue&type=script&lang=js"
export * from "./ProjectHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__